// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".footer-portal[data-v-eefa1202]{background-color:var(--portalNav);color:#fff;padding-top:30px;padding-bottom:25px;display:flex;justify-content:center}.yelowLine[data-v-eefa1202]{background-color:#fff212;height:5px}.ajust-image-footer[data-v-eefa1202]{height:100px;min-width:100px;margin-left:5px}.texts-footer[data-v-eefa1202]{border-left:2px solid;padding-left:10px}", ""]);
// Exports
module.exports = exports;
